

import Carousel, { CarouselResponsiveOptions } from 'primevue/carousel';
import { ref } from 'vue';

export default {
	name: 'CarouselGame2',
	components: {
		Carousel,
	},
	setup() {
		const products = ref([
			{
				image: 'https://topgame-storage.sgp1.cdn.digitaloceanspaces.com/theme/page/product-1.webp',
				name: 'name',
				href: '/slot',
			},
			{
				image: 'https://topgame-storage.sgp1.cdn.digitaloceanspaces.com/theme/page/product-2.webp',
				name: 'name',
				href: '/slot',
			},
			{
				image: 'https://topgame-storage.sgp1.cdn.digitaloceanspaces.com/theme/page/product-3.webp',
				name: 'name',
				href: '/slot',
			},
			{
				image: 'https://topgame-storage.sgp1.cdn.digitaloceanspaces.com/theme/page/product-4.webp',
				name: 'name',
				href: '/slot',
			},
			{
				image: 'https://topgame-storage.sgp1.cdn.digitaloceanspaces.com/theme/page/product-5.webp',
				name: 'name',
				href: '/slot',
			},
			{
				image: 'https://topgame-storage.sgp1.cdn.digitaloceanspaces.com/theme/page/product-6.webp',
				name: 'name',
				href: '/slot',
			},
		]);

		const responsiveOptions = ref<CarouselResponsiveOptions[]>([
			{
				breakpoint: '1400px',
				numVisible: 5,
				numScroll: 1
			},
			{
				breakpoint: '1199px',
				numVisible: 4,
				numScroll: 1
			},
			{
				breakpoint: '767px',
				numVisible: 2,
				numScroll: 1
			},
			{
				breakpoint: '575px',
				numVisible: 1,
				numScroll: 1
			}
		]);


		return {
			products,
			responsiveOptions,
		}
	}
}
